import { type SetToolsResponse, setToolsResponseSchema } from "../types";
import { enduserApi } from "./client";

/**
 * Persist the end-user's tool selection. The request body carries ONLY the
 * chosen tool refs — never a project id, subject, or IdP groups. The BFF derives
 * the caller's identity and project from the `arcade_eu_session` cookie, so any
 * client-supplied scope would be untrusted and is deliberately omitted.
 */
export const setTools = async (tools: string[]): Promise<SetToolsResponse> => {
  const { data } = await enduserApi.put<unknown>("/me/tools", { tools });
  return setToolsResponseSchema.parse(data);
};
